// extracted by mini-css-extract-plugin
module.exports = {"location":"styles_location__w6AHf","id":"styles_id__C0FKq","drawer":"styles_drawer__25UM9","expo":"styles_expo__4_6Ei","btn":"styles_btn__3yMY6"};